import React, { useState, useRef, useEffect } from 'react';
import { CiCalendarDate } from "react-icons/ci";
import { GrClose } from "react-icons/gr";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format, addDays, isSameDay } from 'date-fns';
import "./SearchBarStyle.css";

const DateRangeSelect = ({
    dateRange,
    onChange,
    placeholder = "Date"
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Convert [start, end] array to object expected by DateRange
    const range = [
        {
            startDate: dateRange[0] || new Date(),
            endDate: dateRange[1] || new Date(),
            key: 'selection'
        }
    ];

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isOpen && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleSelect = (ranges) => {
        const { selection } = ranges;
        onChange([selection.startDate, selection.endDate]);
    };

    const handlePreset = (days) => {
        const today = new Date();
        const endDate = addDays(today, days);
        onChange([today, endDate]);
    };

    const clearSelection = (e) => {
        e.stopPropagation();
        onChange([null, null]);
    };

    const hasSelection = dateRange[0] && dateRange[1];

    let formattedSelection = "";
    if (hasSelection) {
        const start = dateRange[0];
        const end = dateRange[1];
        if (isSameDay(start, end)) {
            formattedSelection = format(start, 'MMM dd, yyyy');
        } else {
            formattedSelection = `${format(start, 'MMM dd, yyyy')} - ${format(end, 'MMM dd, yyyy')}`;
        }
    }

    return (
        <div className="search-field-wrapper" ref={dropdownRef}>
            <CiCalendarDate className="search-icon" />
            <div className="custom-select-container">
                <div
                    className="custom-select-trigger"
                    onClick={toggleDropdown}
                    style={{ display: 'flex', alignItems: 'center', width: '100%' }}
                >
                    {!hasSelection ? (
                        <span className="placeholder-text">{placeholder}</span>
                    ) : (
                        <span
                            className="selected-text"
                            style={{
                                flex: 1,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                marginRight: '8px',
                                minWidth: 0
                            }}
                            title={formattedSelection} // Show full text on hover
                        >
                            {formattedSelection}
                        </span>
                    )}
                    {hasSelection && (
                        <GrClose
                            className="close-icon"
                            style={{
                                marginLeft: '0',
                                fontSize: '12px',
                                flexShrink: 0,
                                cursor: 'pointer'
                            }}
                            onClick={clearSelection}
                        />
                    )}
                </div>

                {isOpen && (
                    <div className="custom-dropdown-menu date-range-dropdown">
                        <DateRange
                            editableDateInputs={false}
                            onChange={handleSelect}
                            moveRangeOnFirstSelection={false}
                            ranges={range}
                            minDate={new Date()}
                            rangeColors={['#ddb467']} // Match brand gold
                            showDateDisplay={false}
                        />

                        <div className="date-range-footer" style={{ padding: '12px', borderTop: '1px solid #eff2f7' }}>
                            <div className="preset-options" style={{ display: 'flex', gap: '8px', marginBottom: '12px', flexWrap: 'nowrap', overflowX: 'auto' }}>
                                <button
                                    className="preset-chip"
                                    onClick={() => handlePreset(0)}
                                    style={{ border: '1px solid #eff2f7', background: 'white', borderRadius: '16px', padding: '4px 12px', fontSize: '12px', color: '#666', whiteSpace: 'nowrap' }}
                                >
                                    Today
                                </button>
                                <button
                                    className="preset-chip"
                                    onClick={() => handlePreset(3)}
                                    style={{ border: '1px solid #eff2f7', background: 'white', borderRadius: '16px', padding: '4px 12px', fontSize: '12px', color: '#666', whiteSpace: 'nowrap' }}
                                >
                                    Next 3 Days
                                </button>
                                <button
                                    className="preset-chip"
                                    onClick={() => handlePreset(7)}
                                    style={{ border: '1px solid #eff2f7', background: 'white', borderRadius: '16px', padding: '4px 12px', fontSize: '12px', color: '#666', whiteSpace: 'nowrap' }}
                                >
                                    Next 7 Days
                                </button>
                            </div>
                            <button
                                className="apply-btn"
                                onClick={() => setIsOpen(false)}
                                style={{
                                    width: '100%',
                                    backgroundColor: '#ddb467',
                                    color: 'white',
                                    border: 'none',
                                    padding: '8px',
                                    borderRadius: '4px',
                                    fontWeight: '500',
                                    cursor: 'pointer'
                                }}
                            >
                                Apply
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DateRangeSelect;
